<template>
  <b-form-group v-if="max">
    <template #label>
      <div class="d-flex justify-content-between">
        <span v-if="label">{{ label }}</span>
        <slot
          v-else
          name="label"
        />
        <div>
          <b-badge
            :variant="state === null ? 'success' : 'danger'"
            class=""
          >
            {{ count }}/{{ max }}
          </b-badge>
          <b-icon
            v-if="maxEditable"
            id="edit-max-chars"
            icon="pencil"
            class="cursor-pointer"
          />
          <b-popover
            v-if="maxEditable"
            target="edit-max-chars"
            placement="bottomleft"
            :show.sync="popoverShow"
          >
            <b-input
              v-model="editableMaxChars"
              class="mb-2"
            />
            <b-button
              variant="primary"
              @click="editMaxCharsHandler"
            >
              Update
            </b-button>
          </b-popover>
        </div>
      </div>
    </template>
    <slot :state="state" />
  </b-form-group>
  <b-form-group
    v-else
    :label="label"
  >
    <slot />
  </b-form-group>
</template>

<script>
export default {
  name: 'FormGroupCharLimit',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: ''
    },
    max: {
      type: Number,
      default: null,
    },
    maxEditable: {
      type: Boolean,
      default: () => false,
    }
  },
  data: () => ({
    editableMaxChars: 0,
    popoverShow: false,
  }),
  computed: {
    stringValue() {
      return this.value + '';
    },
    state () {
      return this.count <= this.max && null
    },
    count () {
      return this.stringValue.replace(/<[^>]*>/g, '').length
    },
  },
  watch: {
    max(value) {
      this.editableMaxChars = value;
    },
  },
  mounted() {
    this.editableMaxChars = this.max;
  },
  methods: {
    editMaxCharsHandler() {
      this.$emit('change', Number(this.editableMaxChars))
      this.popoverShow = false
    },
  }
}
</script>

<style scoped>

</style>
